import { ShieldCheck, AlertCircle, HelpCircle } from "lucide-react";

const CONFIG = {
    high: {
        label: "High confidence",
        cls: "bl-badge bl-badge-low",
        Icon: ShieldCheck,
    },
    medium: {
        label: "Medium confidence",
        cls: "bl-badge bl-badge-medium",
        Icon: HelpCircle,
    },
    low: {
        label: "Low confidence",
        cls: "bl-badge bl-badge-high",
        Icon: AlertCircle,
    },
};

export function ConfidenceBadge({ confidence, reasons, className = "" }) {
    const cfg = CONFIG[(confidence || "medium").toLowerCase()] || CONFIG.medium;
    const { Icon } = cfg;
    const reasonText = Array.isArray(reasons) && reasons.length
        ? reasons.join(" · ")
        : null;
    return (
        <span
            className={cfg.cls + " " + className}
            data-testid={`confidence-badge-${(confidence || "medium").toLowerCase()}`}
            title={reasonText || cfg.label}
            aria-label={reasonText ? `${cfg.label} — ${reasonText}` : cfg.label}
            tabIndex={0}
        >
            <Icon className="w-3 h-3" />
            {cfg.label}
        </span>
    );
}

export function MarketTierPill({ profile, className = "" }) {
    if (!profile) return null;
    const tier = profile.tier || "average";
    const tierLabel = {
        high_cost: "High-cost market",
        above_avg: "Above-average market",
        average: "Average market",
        below_avg: "Below-average market",
    }[tier] || "Market";
    return (
        <span
            className={"bl-badge bl-badge-neutral " + className}
            data-testid="market-tier-pill"
            title={`Labor ${profile.labor_mult}× · Material ${profile.material_mult}×`}
        >
            {profile.name} · {tierLabel}
        </span>
    );
}
